import {
  SelfserveapiAgent,
  SelfserveapiBroker,
  SelfserveapiMlsRegistrationRequest,
  SelfserveapiMlsRegistrationResponse,
} from './generated/AccountApi.types';
import { AccountFields } from './AccountForms.types';
export type {
  SelfserveapiSendBrokerOfficeApprovalEmailRequest,
  SelfserveapiSendBrokerOfficeApprovalEmailResponse,
} from './generated/AccountApi.types';

export type MlsRegistrationBroker = SelfserveapiBroker;

export type MlsRegistrationAgent = SelfserveapiAgent;

export type MlsRegistrationRequest = SelfserveapiMlsRegistrationRequest;

export type MlsRegistrationResponse = SelfserveapiMlsRegistrationResponse;

export enum MyStateMlsSignupFields {
  FirstName = AccountFields.FirstName,
  LastName = AccountFields.LastName,
  Email = 'email_address',
  OfficeName = 'office_name',
  StreetAddress = 'address1',
  City = AccountFields.City,
  State = AccountFields.State,
  Zip = 'zip',
  OfficeContactEmail = 'office_contact_email',
  BrokerageApproval = 'brokerage_approval',
}

export interface MyStateMlsSignupFormFields {
  [MyStateMlsSignupFields.FirstName]: string;
  [MyStateMlsSignupFields.LastName]: string;
  [MyStateMlsSignupFields.Email]: string;
  [MyStateMlsSignupFields.OfficeName]: string;
  [MyStateMlsSignupFields.StreetAddress]: string;
  [MyStateMlsSignupFields.City]: string;
  [MyStateMlsSignupFields.State]: string;
  [MyStateMlsSignupFields.Zip]: string;
  [MyStateMlsSignupFields.OfficeContactEmail]: string;
  [MyStateMlsSignupFields.BrokerageApproval]: boolean;
}
